

import { setLoading } from "../../feature/authSlice"
import { apiConstants } from "../apiConstant"
import { serviceCallSendDataArray } from "../serviceCall"

export const savePermissionRoleWiseApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    serviceCallSendDataArray({
      url: apiConstants.AUTH.SAVE_PERMISSION_ROLE_WISE,
      method: 'post',
      data: data,
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
